var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowTopRight = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.38435 2.75H2.375C1.13236 2.75 0.125 3.75736 0.125 5V13.625C0.125 14.8677 1.13236 15.875 2.375 15.875H11.875C13.1176 15.875 14.125 14.8677 14.125 13.625V10.0416H13V13.625C13 14.2463 12.4963 14.75 11.875 14.75H2.375C1.75368 14.75 1.25 14.2463 1.25 13.625V5C1.25 4.37868 1.75368 3.875 2.375 3.875H7.38435V2.75Z",
    fill: "#161616"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.47725 8.72725C6.25758 8.94692 6.25758 9.30308 6.47725 9.52275C6.69692 9.74242 7.05308 9.74242 7.27275 9.52275L6.47725 8.72725ZM15.3125 1.25C15.3125 0.93934 15.0607 0.6875 14.75 0.687499L9.6875 0.6875C9.37684 0.6875 9.125 0.93934 9.125 1.25C9.125 1.56066 9.37684 1.8125 9.6875 1.8125H14.1875V6.3125C14.1875 6.62316 14.4393 6.875 14.75 6.875C15.0607 6.875 15.3125 6.62316 15.3125 6.3125L15.3125 1.25ZM7.27275 9.52275L15.1477 1.64775L14.3523 0.852252L6.47725 8.72725L7.27275 9.52275Z",
    fill: "#161616"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowTopRight);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrow_top_right.e60969a0f3abcad4dc0f5404355d321c.svg";